export default "__VITE_ASSET__b5c22445__"